import { Skeleton, SkeletonVariants, SortingState, PaginationState } from '@cx/ui';
import { DataGridSkeletonStyled } from 'features/DataGrid/DataGridStyling';
import { useRef, useState, useEffect } from 'react';

const columns = [
  {
    id: 'col1',
    accessorKey: 'col1',
    header: () => '',
    cell: () => <Skeleton variant={SkeletonVariants.rectangular} />,
  },
  {
    id: 'col2',
    accessorKey: 'col2',
    header: () => '',
    cell: () => <Skeleton variant={SkeletonVariants.rectangular} />,
  },
  {
    id: 'col3',
    accessorKey: 'col3',
    header: () => '',
    cell: () => <Skeleton variant={SkeletonVariants.rectangular} />,
  },
  {
    id: 'col4',
    accessorKey: 'col4',
    header: () => '',
    cell: () => <Skeleton variant={SkeletonVariants.rectangular} />,
  },
];
const computeRows = (itemsCount: number) => {
  return Array.from({ length: itemsCount }, (_, i) => ({
    id: i,
    col1: '',
    col2: '',
    col3: '',
    col4: '',
  }));
};
const DynamicTableLoadingSkeleton = () => {
  const parentRef = useRef<HTMLDivElement | null>(null);
  const [itemsCount, setItemsCount] = useState(5);
  const [data, setData] = useState<any[]>(computeRows(5));
  const [sorting, setSorting] = useState<SortingState>([]);
  const [paginationState, setPaginationState] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 5,
  });

  const calculateItems = () => {
    if (parentRef.current) {
      const { height } = parentRef?.current?.getBoundingClientRect() ?? 0;
      const itemSize = 55;
      const rows = Math.max(5, Math.floor(height / itemSize));
      setItemsCount(rows);
    }
  };

  useEffect(() => {
    const dummyData = computeRows(itemsCount);
    setData(dummyData);
  }, [itemsCount]);

  useEffect(() => {
    calculateItems(); // Initial calculation
    const resizeObserver = new ResizeObserver(() => calculateItems());
    if (parentRef.current) resizeObserver.observe(parentRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div
      className="cardOverlay"
      ref={parentRef}
      style={{
        height: '100%',
      }}
    >
      <DataGridSkeletonStyled
        columns={columns}
        data={data}
        pagination={paginationState}
        paginationOptions={{
          onPaginationChange: setPaginationState,
        }}
        sorting={sorting}
        sortingOptions={{
          onSortingChange: setSorting,
        }}
      />
    </div>
  );
};

export default DynamicTableLoadingSkeleton;
